<template>
  <div class="ser-ger">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho" v-if="cpntConsultar === false">
        <App-Filtros
        :cpntMontarCampoF="serGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="serGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="serGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='serGerTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="[ '', null, undefined ].indexOf(cpntSelecionar) !== -1 && tabper !== '' && $route.name !== 'prod_exc' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, [ 533 ], 'OR', false) === true">
            <App-Button :data-time="time" 
            :cpntId='botao.id'
            :cpntStatus='botao.status' 
            :cpntIcone='botao.icone'
            :cpntClass='botao.class'
            :cpntDisabled="botao.disabled"
            @onClick='botao.onClick'>
            {{ 'Novo Serviço' }}
            </App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntFiltros="$refs.filtros"
        :cpntSetarFiltros="cpntConsultar !== false ? undefined : serGerTabSetarFiltros"
        :cpntMontarFiltros="cpntConsultar !== false ? undefined : serGerTabMontarFiltros"
        :cpntMontarWhere="cpntConsultar !== false ? undefined : serGerTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"

        :cpntMostrarMper="cpntConsultar === false"
        :cpntApiTabPerFiltros="cpntConsultar === false && cpntSelecionar === null"
        :cpntApiTabPerRpp="cpntConsultar === false && cpntSelecionar === null ? undefined : null"
        :cpntApiTabPerOrder="cpntConsultar === false && cpntSelecionar === null ? tabPerOrder : null"
        :cpntApiTabPer="cpntConsultar === false && cpntSelecionar === null ? tabper : null"

        :cpntBotaoExportar="exportar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntBotaoEditar="botaoEditar"
        :cpntSetarValores="serGerTabSetarLinhas"
        :cpntApiRouter="cpntConsultar === false ? route : null"
        :cpntApiWhere="where"
        :cpntApiOrder="order"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='serGerTabMarcarCheckbox'
        ref="tabela">
          <!-- SETA O ICONE DA MINHA PERSONALIZAÇÃO -->
          <template slot="mper-icone" v-if="cpntSelecionar !== null">
            <svg class="far fa-eye"></svg>
          </template>

          <!-- <template slot="botoes2" v-if="$store.state.etiAntiga !== true">
            <App-Button :data-time="time" :cpntIcone="'cod_barras'" title="Clique aqui para gerar a etiqueta" @onClick="botaoEtiqueta.onClick"></App-Button>
            <App-Button :data-time="time" style="padding: 2px 3px;" :cpntIcone="'info'" title="Clique aqui para gerar relatorios" @onClick="(cpntId, event) => { serGerTabMostrarDialogRelatorio(event) } " ref="btDialogRel"></App-Button>
          </template> -->

          <!-- COLOCA FRASE SOBRE O TOP DA TABELA -->
          <template slot="cabecalho" v-if="$route.name === 'prod_exc'">
            <div style="color: red; font-weight: bold; text-align: center; font-size: var(--font-base-soma-12);">
              Os registros abaixo estão excluídos / desativados.
            </div>
          </template>

          <!-- BOTAO REATIVAR REGISTRO EXCLUIDO -->
          <template slot="botoes" v-if="[ '', null, undefined ].indexOf(botaoReativar) === -1">
            <App-Button :cpntIcone="'reativar'" :cpntStatus="botaoReativar !== 'carregando' ? '' : 'carregando'" :cpntClass="'btn btn-info btn-sm'" :cpntExplica="{ mensagem: 'Selecione o servico desejados para serem reativados.' }" @onClick='() => { botaoReativar() }'>
            </App-Button>
          </template>

          <!-- COLUNA nome -->
          <template v-slot:col_nome="{ linha }">
            <div v-if="cpntConsultar !== false">
              <span v-html="linha.nome"></span>
            </div>
            <!-- this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, [ 534 ], null, false) === true -->
            <App-Button v-else :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" :class="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, [ 534 ], null, false) === false ? 'app-cadastro-link-disabled' : ''" @onClick='() => { serGerTabAbrirCadastro("servico", linha.id) }'>
              <span v-html="linha.nome"></span>
            </App-Button>
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.last_user_usuario + '<br/>' + linha.last_at_ptbr"></span>
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_tp_valor="{ linha }">
            <template v-if="linha.tp_valor === '1'">
              %
            </template>
            <template v-else>
              R$
            </template>
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_valor="{ linha }">
            <template v-if="linha.tp_valor === '1'">
              {{ $store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', Number(linha.valor / 100).toString()) }}% do Total da Venda
            </template>
            <template v-else>
              R$ {{ $store.state.FUN_MASK_VALOR('valorDecimalNovo', Number(linha.valor / 100).toString()) }}
            </template>
          </template>

          <!-- SETA O BOTÃO HISTORICO -->
          <template v-slot:col_historico="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-info', 'btn-sm' ]" :cpntTexto="'Histórico'" @onClick='() => { serGerTabAbrirHistorico(linha) }'></App-Button>
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>

          <!-- SETA O SLOT PARA RECEBER O BOTÃO CARREGAR MAIS DO ALT+P -->
          <template slot="tabela_carregar_mais" v-if="Object.keys($slots).indexOf('carregar_mais') !== -1">
            <slot name="carregar_mais"></slot>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view v-if="cpntSelecionar === null && cpntConsultar === false" :cpntFecharFormulario="serGerTabFecharFormulario" @ATUALIZAR_INFORMACOES_EXTERNAS="() => { serGerTabBuscarLinhas() }"></router-view>
  </div>
</template>

<style scoped>
.ser-ger-etiqueta {
  padding-top: 10px;
  text-align: right;
  margin-bottom: -15px;
}

.ser-ger-bt > ul {
  /* margin-top: 10px; */
  margin-bottom: 0px;
  text-decoration: none;
  list-style: none;
}
  .ser-ger-bt > ul > li {
    padding: 6px 10px;
    border: 1px solid #fff;
    cursor: pointer;
  }
  .ser-ger-bt > ul > li:hover {
    color: #fff;
    background-color: #219dab;
    border-radius: 4px;
  }
</style>

<style>
.ser-ger > .tabela > table > tbody > tr > td.col_virtual_qtde_estoque > div > span > b,
.ser-ger > .tabela > table > tbody > tr > td.col_virtual_qtde_estoque_com_clu_sincronizada > div > span > b {
  font-size: 15px;
}

.ser-ger > .tabela > table > tbody > tr > td.col_cod_barra {
  text-align: right;
  width: 140px;
  min-width: 140px;
}
  .ser-ger > .tabela > table > tbody > tr > td.col_cod_barra > div > span > button {
    margin-left: 5px;
    padding: 2px 5px;
  }
    .ser-ger > .tabela > table > tbody > tr > td.col_cod_barra > div> span > button > span > svg {
      font-size: 18px;
      color: #000
    }
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntConsultar: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        conferencia: [],
        tabper: 'Servico',
        route: '/servico/get',
        planilhaAtu: false,
        relatorioBT: false,
        botao: {
          status: '',
          texto: 'Novo  Serviço',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => {
            // MONTA OS PARAMETROS DA ROTA
            var params = { name: 'serv_form', params: { id: 0 } }

            // MANDA ABRIR A ROTA SOLICITADA
            this.$router.push(params)
          }
        },
        botaoEtiqueta: {
          status: '',
          texto: 'Gerar etiquetas',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrar: true,
          expolica: { mensagem: 'Clique e selecione os servicos para gerar etiquetas.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
          mostrarEtiqueta: false,
          onClick: () => {
            if (this.$store.state.etiAntiga === true) {
              // SETA SE DEVE MOSTRAR A TELA PARA GERAR A ETIQUETA
              this.botaoEtiqueta.mostrarEtiqueta = !this.botaoEtiqueta.mostrarEtiqueta
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            } else {
              if ([ '', null, undefined ].indexOf(this.checkbox) === -1 && this.checkbox.length >= 1) {
                // INICIA OS PARAMETROS
                var params = { tipo: 'GERAR_ETIQUETA', model: 'servico' }

                // VERIFICA SE TEM IDS SELECIONADOS
                params.ids = JSON.parse(JSON.stringify(this.checkbox))
        
                // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
                this.$store.commit('SET_ABRIR_CADASTRO', params)
              } else {
                this.$store.state.msgWarn('WEB [406]: Selecione ao menos um item para gerar etiqueta.', 'danger')
              }
            }
          }
        },
        colunas: [],
        linha: [],
        fazerOrdenacao: true,
        tabPerOrder: [
          { id: '0', nome: 'Última Alteração',      chave: 'last_at',     order: 'desc' },
          { id: '1', nome: 'Código Crescente',      chave: 'id',          order: 'asc' },
          { id: '2', nome: 'Ordem Alfabética',      chave: 'nome',        order: 'asc' },
          { id: '3', nome: 'Código Decrescente',    chave: 'id',          order: 'desc' }
        ],  
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined,
        botaoQtdeTotalEstoque: undefined,
        exportar: undefined,
        qtdeEstoqueTotal: undefined
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.serGerTabSetarStatusGeral('carregando')

      // INICIA O CARREGAMENTO
      this.serGerTabBuscarLinhas()
    },
    methods: {
      serGerTabFecharFormulario: function (atualizar) {
        // SETA A ATUALIZAÇÃO DO PRODUTO
        this.planilhaAtu = false

        // VERIFICA SE TEM QUE ATUALIZAR A LISTA DE PRODUTO
        if (atualizar === true) {
          this.serGerTabBuscarLinhas()
        }
      },
      serGerTabBuscarLinhas: function () {
        // LIMPA A VARIAVEL
        this.conferencia = []

        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = null
        this.botaoExcluir = null
        this.botaoReativar = null
        this.exportar = null
        this.qtdeEstoqueTotal = null
        this.botaoQtdeTotalEstoque = null

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // VERIFICA SE ESTÁ PAGINA DEVE APRESENTAR O BOTÃO EXCLUIR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) !== -1 && this.cpntConsultar === false) {
          if (this.$route.name !== 'prod_exc') {
            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, [ 534 ], null, false) === true) {
              this.botaoEditar = this.serGerTabEditar
            }
    
            // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
            if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, [ 535 ], null, false) === true) {
              this.botaoExcluir = this.serGerTabExcluir
            }

            // SETA OS PARAMETROS PARA EXPORTAÇÃO
            this.exportar = {
              format: [ 'xlsx', 'pdf' ],
              search: true,
              // field: [  
              //   { id:                                         'Código.'                                              },
              //   { nome:                                       'Nome'                                                 },
              //   { id_cat_nome:                                'Categoria'                                            },
              //   { id_mar_nome:                                'Marca'                                                },
              //   { tp_valor:                                   'Tipo'                                                 },
              //   { valor:                                      { a: 'Valor', format: "bdtoreal" }                     },
              //   { obs:                                        'Observações'                                          },
              //   { last_user_usuario:                          'Alterado por'                                         },
              //   { last_at_ptbr:                               'Ultima alteração'                                     }
              // ]
            }
          } else {
            // SETA O BOTÃO REATIVAR
            this.botaoReativar = this.serGerTabReativar

            // SETA O WHERE QUE DEVE REALIZAR
            this.where = { aAnd: [ { f: 'status', o: '=', v: '0' } ] }
          }
        }

        // switch (this.$route.name) {
        //   case 'prod_exc':
        //     this.where = { aAnd: [ { f: 'status', o: '=', v: '0' } ] }
        //     break

        //   case 'prod_gere':
        //   case 'prod_form':
        //     this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'servico_acabado', o: '=', v: 's' } ] }
        //     break

        //   case 'insumo_gere':
        //   case 'insumo_form':
        //     this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'insumo', o: '=', v: 's' } ] }
        //     break
        // }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,  chave: 'id',             tipo: 'checkbox',         export: { fields: {} } },
          { mPer: 2,  chave: 'id',             nome: 'Cód.',             export: { fields: {} } },
          { mPer: 2,  chave: 'nome',           nome: 'Nome',             export: { fields: {} } },
          { mPer: 1,  chave: 'id_cat_nome',    nome: 'Categoria',        export: { fields: {} } },
          { mPer: 1,  chave: 'valor',          nome: 'Valor',            export: { fields: { tp_valor: 'Tipo Valor', valor: { a: 'Valor', format: "bdtoreal" } } } },
          { mPer: 1,  chave: 'obs',            nome: 'Observação',       export: { fields: {} } },
          { mPer: 1,  chave: 'last',           nome: 'Última Alteração', export: { fields: { last_user_usuario: 'Alterado por', last_at_ptbr: 'Ultima alteração' } } },
          { mPer: 1,  chave: 'historico',      nome: 'Histórico',        export: { fields: {} } },
        ]

        // SETA OS CAMPOS QUE DEVE BUSCAR
        this.field = {
          id: null,
          nome: null,
          id_cat: { j: { nome: null } },
          valor: null,
          tp_valor: null,
          obs: null,
          last_at: null,
          last_user: { j: { usuario: null } },
        }

        // SETA OS CAMPOS VIRTUAIS QUE DEVE BUSCAR
        this.fieldVir = []

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // VERIFICA SE TEM QUE A PERMISSÃO PARA VER O BOTÃO HISTORICO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 33 ], null, false) === false) {
          remover = remover.concat([ 'historico' ])
        }

        // REMOVE AS COLUNAS QUE NÃO DEVE APRESENTAR
        if (this.$route.name === 'prod_exc') {
          remover = remover.concat([ 'historico' ])
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if (this.cpntConsultar !== false) {
          for (var indexI in colunas) {
            if ([ 'codigo', 'nome', 'rf-valor', 'rf-tp_valor' ].indexOf(colunas[indexI].chave) === -1) {
              remover.push(colunas[indexI].chave)
            }
          }

          // LIMPA OS CAMPOS VIRTUAIS
          this.fieldVir = []
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
          // ADICIONA O VALOR QUE NÃO DEVE COLOCAR ORDENAÇÃO MPER
          this.estruturaQueryGet[0].push('sem_order_mper')

          // LIMPA A ORDENAÇÃO DA TABELA
          this.order = { last_at: 'desc' }

          // REMOVE AS COLUNAS QUE NÃO PODEM SER COPAIDAS
          remover = remover.concat([ 'id', 'last', 'historico' ])

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && this.statusGeral === '') {
          this.serGerTabReiniciar()
        } else {
          this.serGerTabSetarStatusGeral('')
        }
      },
      serGerTabAbrirCadastro: function (tipo, id) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 15 ], null, [ 25 ], null, [ 534 ], null, false) === true) {
          // SETA OS PARAMETROS QUE SERÁ ENVIADO
          var params = { editar: false, tipo: tipo, id: id }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.serGerTabBuscarLinhas()
            }
          }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callbackAtu = () => { this.serGerTabBuscarLinhas() }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      serGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}

        // FAZ A QUEBRA DE SINCRONIMOS DO VUE
        where = JSON.parse(JSON.stringify(where))
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // CONVERTE O ARRAY EM STRING
        if (Array.isArray(where.v) === true) {
          where.v = where.v.join(',')
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'codigo':
            retorno.where = { f: 'id', o: 'in', v: where.v }
            break

          case 'nome':
            if (where.o === '=') {
              retorno.where = { f: 'id', o: 'in', v: where.v }
            } else {
              retorno.where = Object.assign(where, { f: 'nome' })
            }
            break

          case 'id_cat':
            retorno.where = { f: where.f, o: 'in', v: where.v }
            break

          case 'last_at':
            // IMPORTA BIBLIOTECA DEPENDENTE
            var moment = require('moment')

            // VERIFICA SE TEM QUE GERAR O VALOR
            if ([ '', null, undefined ].indexOf(where.v._dataIni) !== -1) {
              where.v._dataIni = moment(where.v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            if ([ '', null, undefined ].indexOf(where.v._dataFim) !== -1) {
              where.v._dataFim = moment(where.v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }

            // SETA O WHERE QUE DEVE REALIZAR
            if (where.o === '=') {
              retorno.where = { aAnd: [
                { f: 'last_at', o: '>=', v: where.v._dataIni + ' 00:00:00' },
                { f: 'last_at', o: '<=', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if (where.o === '<>') {
              retorno.where = { aOr: [
                { f: 'last_at', o: '<', v: where.v._dataIni + ' 00:00:00' },
                { f: 'last_at', o: '>', v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '<=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'last_at', o: where.o, v: where.v._dataFim + ' 23:59:59' }
              ] }
            } else if ([ '>=' ].indexOf(where.o) !== -1) {
              retorno.where = { aOr: [
                { f: 'last_at', o: '>', v: where.v._dataIni + ' 00:00:00' }
              ] }
            }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { o: 's.ft', v: where.v }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false
            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      serGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      serGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.serGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      serGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (this.cpntConsultar !== false) {
          callback()
        } else if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            // VERIFICA SE TEM QUE ALTERAR O FILTRO DO CAMPO
            if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1 && ([ '', null, undefined ].indexOf(filtros) !== -1 || (Array.isArray(filtros) === true && filtros.length === 0))) {
              filtros = this.cpntFiltros
            }

            // SETA O FILTRO NA TELA
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.serGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      serGerTabMontarFiltros: function (callback, tentativa = 0) {
        if (this.cpntConsultar !== false) {
          callback([])
        } else if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.serGerTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      serGerTabSetarLinhas: function (vetor) {
        // SETA OS IDS SOLICITADOS
        // for (var index in vetor) {
        // }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      serGerTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      serGerTabReativar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente reativar o(s) servico(s) selecionados?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoReativar = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/servico/reativar', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // MANDA ATUALIZAR A TABELA
                this.serGerTabBuscarLinhas()
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoReativar = this.serGerTabReativar

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.serGerTabSetarStatusGeral)
        }
      },
      serGerTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'serv_form', params: { id: ids } })
        }
      },
      serGerTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) serviço(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/servico', 'DELETE', formData, (apiSuccess) => {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // MANDA ATUALIZAR A TABELA
            this.serGerTabBuscarLinhas()

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.serGerTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.serGerTabSetarStatusGeral)
        }
      },
      serGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { id: 'codigo',       nome: 'Código' },
          { id: 'nome',         nome: 'Nome' },
          { id: 'id_cat',       nome: 'Categoria' },
          { id: 'last_at',      nome: 'Última Alteração' },
          { id: 'last_user',    nome: 'Alterado por' },
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      serGerTabOnBuscarOptionsFiltroO: function (callback, vetor) {
        // INICIA O VETOR PARA OS CAMPOS
        var seletor = {}

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (vetor.f) {
          case 'nome':
            seletor.options = [
              { id: '%',    nome: '% Contém', _formatar: [ 'id' ] },
              { id: '=',    nome: '= Igual',  _formatar: [ 'id' ] }
            ]
            break

          case 'codigo':
            seletor.options = [
              { id: '=',    nome: '= Igual',  _formatar: [ 'id' ] }
            ]
            break

          case 'id_cat':
          case 'id_mar':
          case 'last_at':
          case 'last_user':
            seletor.options = [
              { id: '=',    nome: '= Igual',      _formatar: [ 'id' ] },
              { id: '<>',   nome: '<> Diferente', _formatar: [ 'id' ] }
            ]
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(seletor)
      },
      serGerTabOnBuscarOptionsFiltroV: function (callback, vetor) {
        // INICIA A FUNÇÃO PARA FINALIZAR
        var finalizar = null

        // INICIA O VETOR PARA OS CAMPOS
        var seletor = {}

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (vetor.f + '_' + vetor.o) {
          case 'nome_%':
          case 'codigo_=':
            seletor.tipo = 'input'

            // VERIFICA SE É O NCM E LIBERA O CAMPO VAZIO PARA BUSCA
            if ([ 'ncm', 'cest' ].indexOf(vetor.f) !== -1) {
              seletor.vazio = true
            }
            break

          case 'nome_=':
            seletor = {
              tipo: 'autocomplite',
              router: '/servico/get',
              method: 'POST',
              field: { id: null, codigo: null, nome: null },
              where: { aAnd: [ { o: 's.ft', v: '#BUSCA#' } ] },
              keyValue: 'id',
              keyMostra: [ 'codigo', ' - ', 'nome' ],
              value: '',
              options: [],
              multiple: true,
              tab: {
                coluna: [
                  { mPer: 1, chave: 'codigo', nome: 'Código' },
                  { mPer: 1, chave: 'nome', nome: 'Nome' },
                  { mPer: 1, chave: 'botao', nome: 'Excluir' }
                ],
                linha: []
              }
            }
            break

          case 'last_at_=':
          case 'last_at_<>':
            seletor = Object.assign(seletor, {
              multiple: false,
              tipo: 'seletor-data',
              optionInicialNome: '',
              value: '30'
            })
            break

          case 'last_user_=':
          case 'last_user_<>':
            // SETA A VARIAVEL
            finalizar = ''

            // BUSCA OS USUARIOS
            this.serGerTabBuscarUsuarios((options) => {
              seletor = Object.assign(seletor, {
                options: options,
                keyValue: 'id',
                keyMostra: [ 'usuario' ],
                tab: {
                  limparOptions: false,
                  coluna: [
                    { mPer: 1, chave: 'usuario', nome: 'Nome' },
                    { mPer: 1, chave: 'botao', nome: 'Excluir' }
                  ],
                  linha: [],
                  notIn: []
                }
              })

              // RETORNA O VALOR MONTADO PARA O CAMPO
              callback(seletor)
            })
            break

          case 'id_cat_=':
            // SETA A VARIAVEL
            finalizar = ''

            // BUSCA OS USUARIOS
            this.serGerTabBuscarCategoria((options) => {
              seletor = Object.assign(seletor, {
                options: options,
                keyValue: 'id',
                keyMostra: [ 'nome' ],
                tab: {
                  limparOptions: false,
                  coluna: [
                    { mPer: 1, chave: 'nome', nome: 'Nome' },
                    { mPer: 1, chave: 'botao', nome: 'Excluir' }
                  ],
                  linha: [],
                  notIn: []
                }
              })

              // RETORNA O VALOR MONTADO PARA O CAMPO
              callback(seletor)
            })
            break
        }

        // RETORNA O VALOR MONTADO
        if (finalizar === null && Object.keys(seletor).length >= 1) {
          callback(seletor)
        }
      },
      serGerTabBuscarCategoria: function (callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null } }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/servico/categoria/get/', 'GET', queryGet, (retorno) => {
          callback(retorno.data)
        }, this.serGerTabSetarStatusGeral)
      },
      serGerTabBuscarUsuarios: function (callback) {
        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, usuario: null } }

        // SETA BUSCA QUE DEVE REALIZAR
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'usuario', o: '<>', v: 'SuporteRF' } ] }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/usuario/get', 'POST', queryGet, (retorno) => {
          callback(retorno.data)
        }, this.serGerTabSetarStatusGeral)
      },
      serGerTabAbrirHistorico: function (linha) {
        // CARREGA OS PARAMETROS
        var params = { name: 'servico_historico_busca', params: { cts: this.$store.state.token.cts, cpntFiltros: window.btoa(JSON.stringify({ ser: [ linha.id.toString() ] })) } }

        // ABRE O RECIBO DA DEMANDA SOLICITADO
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve(params).href, '_blank', {}, false)
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== 'serv_form' && routeAtual.name !== 'serv_form') {
          // SETA O STATUS DA PAGINA
          this.serGerTabSetarStatusGeral('carregando')

          // LIMPA OS VALORES PARA NÃO APRESENTAR ERRADO
          this.checkbox = []
          this.where = {}
          this.linha = []
          this.colunas = []

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.serGerTabBuscarLinhas() }, 500)
        }
      }
    }
  }
</script>
